var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { omit } from 'lodash-es';
import axios from 'axios';
import qs from 'qs';
import { Loading } from '@funny/widgets';
import { getGlobalParams, getQuery, env, decrypt } from '@funny/env';
var symbolJson = '__cb__request_json__';
var cbActGlobalInfo = '__cb_act_global_info__';
var isDev = process.env.NODE_ENV !== 'production';
var storageActInfo = {
    actId: '',
    lotteryIds: [],
    exchangeIds: [],
    levelIds: [],
    memberId: '',
    collectionIds: [],
};
function getMockPrefix() {
    var address = {
        changba: 'https://yapi.changbaops.com/mock/32/www',
        mars: 'https://yapi.changbaops.com/mock/39/mars',
    };
    var type = env.browser.isMarsProject ? 'mars' : 'changba';
    return address[type];
}
var Request = /** @class */ (function () {
    function Request() {
        var _this = this;
        this.loading = new Loading();
        /**
         * URL前缀
         */
        this.baseURL = '';
        // 创建axios实例
        this.instance = axios.create({
            timeout: 30000,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            transformRequest: [
                function (data, headers) {
                    // 对于FormData不进行任何转换
                    if (data instanceof FormData) {
                        return data;
                    }
                    // 指定以JSON的形式传递给后端
                    if ((data === null || data === void 0 ? void 0 : data[symbolJson]) === true) {
                        headers['Content-Type'] = 'application/json; charset=utf-8';
                        // 删除这个临时字段，不发送给后端
                        data === null || data === void 0 ? true : delete data[symbolJson];
                        return JSON.stringify(data);
                    }
                    headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    // 以www-urlencoded的形式传递给后端
                    return qs.stringify(data);
                },
            ],
        });
        this.instance.interceptors.request.use(function (config) {
            var _a = config || {}, _b = _a.showLoading, showLoading = _b === void 0 ? true : _b, loadingConfig = _a.loadingConfig;
            if (showLoading) {
                var mergedConfig = {
                    message: '加载中...',
                    // 设置一个很大的值，让其感觉是不隐藏
                    duration: 1000000000,
                };
                // 字符串配置
                if (typeof loadingConfig === 'string') {
                    mergedConfig.message = loadingConfig;
                }
                // 对象配置
                else if (typeof loadingConfig === 'object' && loadingConfig !== null) {
                    Object.assign(mergedConfig, loadingConfig);
                }
                _this.loading.show(mergedConfig.message, mergedConfig.duration);
            }
            if (config.method === 'get') {
                config.params = config.data;
            }
            else {
                // 不管怎么样，都要保证URL上这两个参数
                var _c = config.data || {}, token = _c.token, userid = _c.userid, curuserid = _c.curuserid;
                config.params = {
                    token: token,
                    userid: userid,
                    curuserid: curuserid,
                };
            }
            return config;
        }, function (error) {
            _this.loading.hide();
            // Do something with request error
            if (isDev) {
                // for debug
                console.log(error);
            }
            Promise.reject(error);
        });
        this.instance.interceptors.response.use(function (response) {
            _this.loading.hide();
            return response;
        }, function (err) {
            _this.loading.hide();
            return Promise.reject(err);
        });
    }
    /**
     * 设置请求的URL前缀
     * @param baseURL
     */
    Request.prototype.setBaseURL = function (baseURL) {
        this.baseURL = baseURL;
    };
    Request.prototype.request = function (url, manualOptions) {
        if (manualOptions === void 0) { manualOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var options, globalParams, uid, formData_1, _loop_1, key, isMock, baseURL;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = __assign({}, manualOptions);
                        // 默认拼接userId和Token
                        if (typeof options.autoTokenWithUserId === 'undefined') {
                            options.autoTokenWithUserId = true;
                        }
                        if (!options.method) {
                            options.method = 'get';
                        }
                        if (!options.data) {
                            options.data = {};
                        }
                        return [4 /*yield*/, getGlobalParams()
                            // 自动添加 userId, token 参数，并且处理好火星活动运行在唱吧+7E的问题
                        ];
                    case 1:
                        globalParams = _a.sent();
                        // 自动添加 userId, token 参数，并且处理好火星活动运行在唱吧+7E的问题
                        if (!options.data.userid && options.autoTokenWithUserId) {
                            uid = globalParams.userId || env.userInfo.userId;
                            options.data.userid = uid;
                            // 火星项目，还需要追加curuserid的参数
                            if (env.browser.isMarsProject && typeof options.data.curuserid === 'undefined') {
                                options.data.curuserid = uid;
                            }
                        }
                        if (!options.data.token && options.autoTokenWithUserId) {
                            options.data.token = globalParams.token || env.userInfo.token;
                        }
                        if (!options.data.smdeviceid) {
                            options.data.smdeviceid = globalParams.smDeviceId;
                        }
                        if (!options.data.uuid) {
                            options.data.uuid = globalParams.uuid;
                        }
                        if (!options.data.os) {
                            options.data.os = env.browser.isAndroid ? 'android' : env.browser.isIOS ? 'ios' : 'unknown';
                        }
                        if (!options.data.appVersion) {
                            options.data.appVersion = globalParams.appVersion;
                        }
                        if (!options.headers) {
                            options.headers = {};
                        }
                        // 将一些重要的信息设置在header上
                        options.headers['x-user-id'] = globalParams.userId;
                        options.headers['x-token'] = globalParams.token;
                        options.headers['x-act-id'] = storageActInfo.actId;
                        if (options.upload === true) {
                            formData_1 = new FormData();
                            _loop_1 = function (key) {
                                if (Object.prototype.hasOwnProperty.call(options.data, key)) {
                                    var value = options.data[key];
                                    if (value === undefined) {
                                        return "continue";
                                    }
                                    if (Array.isArray(value)) {
                                        value.forEach(function (item) {
                                            formData_1.append("".concat(key, "[]"), item);
                                        });
                                    }
                                    else {
                                        formData_1.append(key, value);
                                    }
                                }
                            };
                            // eslint-disable-next-line no-restricted-syntax
                            for (key in options.data) {
                                _loop_1(key);
                            }
                            options.data = formData_1;
                        }
                        else if (options.method === 'post' && options.json === true) {
                            options.data[symbolJson] = true;
                        }
                        if (options.method.toLowerCase() === 'get' && options.cache !== true) {
                            options.data._ = String(+new Date()) + String(Math.floor(Math.random() * 9999));
                        }
                        if (!options.onUploadProgress && options.onUploadPercent) {
                            options.onUploadProgress = (function (progressEvent) {
                                if (progressEvent.lengthComputable) {
                                    typeof options.onUploadPercent === 'function' &&
                                        options.onUploadPercent(Math.floor((progressEvent.loaded / progressEvent.total) * 100), progressEvent);
                                }
                            });
                        }
                        isMock = getQuery('isMock');
                        baseURL = manualOptions.ignoreBaseURL ? '' : this.baseURL;
                        if (isDev && isMock) {
                            // 根据env决定mock的前缀
                            url = getMockPrefix() + baseURL + url;
                        }
                        else {
                            url = baseURL + url;
                        }
                        // 补充请求配置
                        options.showLoading = manualOptions.showLoading;
                        options.loadingConfig = manualOptions.loadingConfig;
                        return [2 /*return*/, this.instance(url, options)
                                .then(function (response) {
                                var _a, _b;
                                var data = response.data;
                                if (!data) {
                                    data = {};
                                }
                                data.$response = response;
                                // 抹平火星上一系列原有的定义
                                var code = (_a = data.errorCode) !== null && _a !== void 0 ? _a : data.code;
                                var msg = (_b = data.message) !== null && _b !== void 0 ? _b : data.msg;
                                if (typeof data.errorCode !== 'undefined') {
                                    delete data.errorCode;
                                }
                                if (typeof data.message !== 'undefined') {
                                    delete data.message;
                                }
                                return __assign(__assign({}, data), { code: code, msg: msg });
                            })
                                .then(function (resp) {
                                var data = resp.data;
                                if (data && Object.keys(data).length === 2 && data.value && data.type === 'encrypt') {
                                    try {
                                        resp.data = JSON.parse(decrypt(data.value));
                                    }
                                    catch (exp) {
                                        console.log('解密失败：', exp);
                                        resp.data = {};
                                    }
                                }
                                return resp;
                            })
                                .catch(function (error) {
                                return {
                                    code: -99999,
                                    data: {},
                                    msg: error.message,
                                    $response: error,
                                };
                            })];
                }
            });
        });
    };
    return Request;
}());
/**
 * 统一封装的请求对象
 */
var request = new Request();
/**
 * 统一封装的get请求方法
 * @param options 请求参数
 * @returns
 */
export function get(options) {
    if (typeof options === 'string') {
        options = {
            url: options,
        };
    }
    var url = options.url;
    var getOptions = omit(options, ['url']);
    return request.request(url, __assign(__assign({}, getOptions), { method: 'get' }));
}
/**
 * 统一封装的post请求方法
 * @param options 请求参数
 * @returns
 */
export function post(options) {
    if (typeof options === 'string') {
        options = {
            url: options,
        };
    }
    var url = options.url;
    var postOptions = omit(options, ['url']);
    return request.request(url, __assign(__assign({}, postOptions), { method: 'post' }));
}
/**
 * 统一封装的delete请求方法
 * @param options 请求参数
 * @returns
 */
function _delete(options) {
    if (typeof options === 'string') {
        options = {
            url: options,
        };
    }
    var url = options.url;
    var deleteOptions = omit(options, ['url']);
    return request.request(url, __assign(__assign({}, deleteOptions), { method: 'delete' }));
}
/**
 * 统一封装的put请求参数
 * @param options 请求参数
 * @returns
 */
export function put(options) {
    if (typeof options === 'string') {
        options = {
            url: options,
        };
    }
    var url = options.url;
    var putOptions = omit(options, ['url']);
    return request.request(url, __assign(__assign({}, putOptions), { method: 'put' }));
}
var _request = request.request.bind(request);
/**
 * 设置请求的URL前缀
 */
export var setBaseURL = request.setBaseURL.bind(request);
export { _delete as del, _request as request };
/**
 * 设置活动配置信息
 */
export function setActConfig(actConfig) {
    // INFO:为什么要把这个变量定义在window上呢，因为组件库依赖的版本可能funny的是不一致的，导致可能需要设置2次，而实际上是没有必要的，因此放在window上
    window[cbActGlobalInfo] = Object.assign(storageActInfo, actConfig);
}
/**
 * 获取活动配置信息
 * @returns
 */
export function getActConfig() {
    return (window[cbActGlobalInfo] || storageActInfo || {});
}
/**
 * 这只是暂时的地址，待后端发布之后可以写死
 */
var host = window.BFF_HOST || 'https://activity-bff.changba.com';
/**
 * 请求服务器地址的前缀
 */
export var baseURL = "".concat(host, "/api/v1");
